import React, { useState, useEffect, useCallback } from 'react';
import api from '../../../services/api';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

const fmt = (n) => Number(n || 0).toLocaleString('pt-BR');
const PERIODS = [
  { id: 'today', label: 'Hoje' }, { id: '7d', label: '7 dias' },
  { id: '30d', label: '30 dias' }, { id: 'season', label: 'Season inteira' },
];
const CUR_LABEL = { BLACK: 'Black Coins', DROPS: 'Gotas', FOX: 'FOX Dólar', RESPECT: 'Respeito' };

export default function OilAdminEconomy({ seasonId }) {
  const [d, setD] = useState(null);
  const [period, setPeriod] = useState('today');

  const load = useCallback(async () => {
    setD(null);
    try {
      const r = await api.get(`/admin/oil/season/${seasonId}/economy`, { params: { period } });
      setD(r.data);
    } catch { toast.error('Erro ao carregar economia.'); }
  }, [seasonId, period]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-3" data-testid="oil-admin-economy">
      <div className="flex flex-wrap gap-1">
        {PERIODS.map((p) => (
          <button key={p.id} onClick={() => setPeriod(p.id)} data-testid={`oil-economy-period-${p.id}`}
            className={`rounded-lg border px-3 py-1 text-xs font-bold ${period === p.id ? 'border-orange-400 bg-orange-50 text-orange-700' : 'text-slate-500'}`}>
            {p.label}
          </button>
        ))}
      </div>

      {!d ? <div className="flex justify-center py-6"><Loader2 className="h-5 w-5 animate-spin text-orange-500" /></div> : (
        <>
          <div className="grid gap-3 md:grid-cols-2">
            {Object.entries(d.by_currency).map(([cur, block]) => (
              <div key={cur} className="rounded-xl border p-3" data-testid={`oil-economy-${cur}`}>
                <div className="flex items-center justify-between">
                  <p className="text-xs font-black uppercase text-slate-600">{CUR_LABEL[cur]}</p>
                  <p className="text-[11px]">
                    <span className="text-emerald-600">+{fmt(block.in)}</span>{' / '}
                    <span className="text-rose-600">-{fmt(block.out)}</span>{' = '}
                    <b className={block.net >= 0 ? 'text-emerald-700' : 'text-rose-700'} data-testid={`oil-economy-net-${cur}`}>{fmt(block.net)}</b>
                  </p>
                </div>
                <div className="mt-1 max-h-44 overflow-y-auto">
                  {block.reasons.map((r) => (
                    <p key={r.label} className="flex items-center justify-between gap-2 border-b py-0.5 text-[11px]">
                      <span className="flex-1 truncate text-slate-600">{r.label} ({r.count}x)</span>
                      <span className="text-emerald-600">+{fmt(r.in)}</span>
                      <span className="text-rose-600">-{fmt(r.out)}</span>
                    </p>
                  ))}
                  {block.reasons.length === 0 && <p className="py-1 text-[11px] text-slate-400">Sem movimentação no período.</p>}
                </div>
              </div>
            ))}
          </div>

          <div className="grid gap-3 md:grid-cols-2">
            {[['top_gainers', 'Top 20 que mais ganharam FOX'], ['top_spenders', 'Top 20 que mais gastaram FOX']].map(([key, title]) => (
              <div key={key} className="rounded-xl border p-3" data-testid={`oil-economy-${key}`}>
                <p className="mb-1 text-xs font-black uppercase text-slate-600">{title}</p>
                {d[key].map((p, i) => (
                  <p key={p.kako_id} className="flex justify-between border-b py-0.5 text-[11px]">
                    <span>{i + 1}. {p.nickname || '—'} <span className="text-slate-400">{p.kako_id}</span></span>
                    <b>{fmt(p.total)}</b>
                  </p>
                ))}
                {d[key].length === 0 && <p className="text-[11px] text-slate-400">Sem dados no período.</p>}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
